import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@sib/auth';
import { UIContextProvider, Layout } from '@sib/ui';
import { SidecarSidebar, TopBar } from '@sidecar/common/components';
import { paths } from '@sidecar/config/paths';
import { routes as authRoutes } from './auth';
import { routes as dashboardRoutes } from './dashboard';
import { routes as organizationsRoutes } from './organizations';
import { routes as projectRoutes } from './projects';
import { routes as vendorsRoutes } from './vendors';

export const routes: RouteObject[] = [
  ...authRoutes,
  // All unprotected routes go above this line
  {
    element: (
      <ProtectedRoute fallbackPath={paths.login}>
        <UIContextProvider>
          <Layout sidebar={<SidecarSidebar />} topbar={<TopBar />}>
            <Outlet />
          </Layout>
        </UIContextProvider>
      </ProtectedRoute>
    ),
    // All protected routes go inside array below
    children: [
      ...dashboardRoutes,
      ...projectRoutes,
      ...organizationsRoutes,
      ...vendorsRoutes,
      {
        path: paths.any,
        index: true,
        element: <Navigate to={paths.projects.root} replace />,
      },
    ],
  },
];
